/* eslint-disable import/no-anonymous-default-export */
import ProfileTypes from "./profile.types";

const INITIAL_STATE = {
  updatePasswordResponse: null,
  updateProfileImageDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** UPDATE PASSWORD START *********************** */
    case ProfileTypes.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePasswordResponse: action.payload,
      };

    case ProfileTypes.UPDATE_PASSWORD_FAILURE:
      return { ...state, updatePasswordResponse: action.payload };

    case ProfileTypes.UPDATE_PASSWORD_RESPONSE_CHANGED:
      return { ...state, updatePasswordResponse: null };

    /** ***************** UPDATE PASSWORD END *********************** */

    /** ***************** UPDATE PROFILE IMAGE DETAILS START *********************** */

    case ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_SUCCESS:
      return { ...state, updateProfileImageDetailsResponse: action.payload };

    case ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_FAILURE:
      return { ...state, updateProfileImageDetailsResponse: action.payload };

    case ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateProfileImageDetailsResponse: null };

    /** ***************** UPDATE PROFILE IMAGE DETAILS END *********************** */

    default:
      return state;
  }
};
